var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const UPDATE_PLATFORM_DATA = "updatePlatformData";
const UPDATE_EVENTS = "updateEvents";
const CLEAR_EVENTS = "clearEvents";
var analyticsModule = {
  namespaced: true,
  state: () => ({
    platformData: {
      environment: "localhost",
      name: void 0,
      appType: void 0,
      applicationId: void 0,
      country: void 0,
      language: void 0,
      jeUserPercentage: void 0,
      currency: void 0,
      version: void 0,
      instancePosition: void 0,
      isPilot: void 0
    },
    userData: {
      "a-UserId": void 0,
      authType: void 0,
      email: void 0,
      globalUserId: void 0,
      signinType: void 0,
      signupDate: void 0
    },
    pageData: {
      name: void 0,
      httpStatusCode: 200,
      conversationId: void 0,
      orientation: void 0
    },
    events: []
  }),
  actions: {
    updatePlatformData: ({ commit }, platformData) => {
      commit(UPDATE_PLATFORM_DATA, platformData);
    },
    updateEvents: ({ commit }, event) => {
      commit(UPDATE_EVENTS, event);
    },
    clearEvents: ({ commit }) => {
      commit(CLEAR_EVENTS);
    }
  },
  mutations: {
    [UPDATE_PLATFORM_DATA]: (state, platformData) => {
      state.platformData = __spreadValues(__spreadValues({}, state.platformData), platformData);
    },
    [UPDATE_EVENTS]: (state, event) => {
      state.events = [...state.events, event];
    },
    [CLEAR_EVENTS]: (state) => {
      state.events = [];
    }
  }
};
const defaultOptions = {
  namespace: "f-analytics",
  globalVarName: "gtm",
  featureName: "feature-name-unset",
  locale: "en-GB",
  id: "gtm-id-unset",
  auth: void 0,
  preview: void 0,
  cookiesWin: void 0
};
function e(e2) {
  this.message = e2;
}
e.prototype = new Error(), e.prototype.name = "InvalidCharacterError";
var r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r2) {
  var t2 = String(r2).replace(/=+$/, "");
  if (t2.length % 4 == 1)
    throw new e("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var n2, o2, a = 0, i = 0, c = ""; o2 = t2.charAt(i++); ~o2 && (n2 = a % 4 ? 64 * n2 + o2 : o2, a++ % 4) ? c += String.fromCharCode(255 & n2 >> (-2 * a & 6)) : 0)
    o2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o2);
  return c;
};
function t(e2) {
  var t2 = e2.replace(/-/g, "+").replace(/_/g, "/");
  switch (t2.length % 4) {
    case 0:
      break;
    case 2:
      t2 += "==";
      break;
    case 3:
      t2 += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(e3) {
      return decodeURIComponent(r(e3).replace(/(.)/g, function(e4, r2) {
        var t3 = r2.charCodeAt(0).toString(16).toUpperCase();
        return t3.length < 2 && (t3 = "0" + t3), "%" + t3;
      }));
    }(t2);
  } catch (e3) {
    return r(t2);
  }
}
function n(e2) {
  this.message = e2;
}
function o(e2, r2) {
  if ("string" != typeof e2)
    throw new n("Invalid token specified");
  var o2 = true === (r2 = r2 || {}).header ? 0 : 1;
  try {
    return JSON.parse(t(e2.split(".")[o2]));
  } catch (e3) {
    throw new n("Invalid token specified: " + e3.message);
  }
}
n.prototype = new Error(), n.prototype.name = "InvalidTokenError";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function commonjsRequire(path) {
  throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var sha256 = { exports: {} };
var core = { exports: {} };
(function(module, exports) {
  (function(root, factory) {
    {
      module.exports = factory();
    }
  })(commonjsGlobal, function() {
    var CryptoJS = CryptoJS || function(Math2, undefined$1) {
      var crypto;
      if (typeof window !== "undefined" && window.crypto) {
        crypto = window.crypto;
      }
      if (!crypto && typeof window !== "undefined" && window.msCrypto) {
        crypto = window.msCrypto;
      }
      if (!crypto && typeof commonjsGlobal !== "undefined" && commonjsGlobal.crypto) {
        crypto = commonjsGlobal.crypto;
      }
      if (!crypto && typeof commonjsRequire === "function") {
        try {
          crypto = require("crypto");
        } catch (err) {
        }
      }
      var cryptoSecureRandomInt = function() {
        if (crypto) {
          if (typeof crypto.getRandomValues === "function") {
            try {
              return crypto.getRandomValues(new Uint32Array(1))[0];
            } catch (err) {
            }
          }
          if (typeof crypto.randomBytes === "function") {
            try {
              return crypto.randomBytes(4).readInt32LE();
            } catch (err) {
            }
          }
        }
        throw new Error("Native crypto module could not be used to get secure random number.");
      };
      var create = Object.create || function() {
        function F() {
        }
        return function(obj) {
          var subtype;
          F.prototype = obj;
          subtype = new F();
          F.prototype = null;
          return subtype;
        };
      }();
      var C = {};
      var C_lib = C.lib = {};
      var Base = C_lib.Base = function() {
        return {
          extend: function(overrides) {
            var subtype = create(this);
            if (overrides) {
              subtype.mixIn(overrides);
            }
            if (!subtype.hasOwnProperty("init") || this.init === subtype.init) {
              subtype.init = function() {
                subtype.$super.init.apply(this, arguments);
              };
            }
            subtype.init.prototype = subtype;
            subtype.$super = this;
            return subtype;
          },
          create: function() {
            var instance = this.extend();
            instance.init.apply(instance, arguments);
            return instance;
          },
          init: function() {
          },
          mixIn: function(properties) {
            for (var propertyName in properties) {
              if (properties.hasOwnProperty(propertyName)) {
                this[propertyName] = properties[propertyName];
              }
            }
            if (properties.hasOwnProperty("toString")) {
              this.toString = properties.toString;
            }
          },
          clone: function() {
            return this.init.prototype.extend(this);
          }
        };
      }();
      var WordArray = C_lib.WordArray = Base.extend({
        init: function(words, sigBytes) {
          words = this.words = words || [];
          if (sigBytes != undefined$1) {
            this.sigBytes = sigBytes;
          } else {
            this.sigBytes = words.length * 4;
          }
        },
        toString: function(encoder) {
          return (encoder || Hex).stringify(this);
        },
        concat: function(wordArray) {
          var thisWords = this.words;
          var thatWords = wordArray.words;
          var thisSigBytes = this.sigBytes;
          var thatSigBytes = wordArray.sigBytes;
          this.clamp();
          if (thisSigBytes % 4) {
            for (var i = 0; i < thatSigBytes; i++) {
              var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 255;
              thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
            }
          } else {
            for (var i = 0; i < thatSigBytes; i += 4) {
              thisWords[thisSigBytes + i >>> 2] = thatWords[i >>> 2];
            }
          }
          this.sigBytes += thatSigBytes;
          return this;
        },
        clamp: function() {
          var words = this.words;
          var sigBytes = this.sigBytes;
          words[sigBytes >>> 2] &= 4294967295 << 32 - sigBytes % 4 * 8;
          words.length = Math2.ceil(sigBytes / 4);
        },
        clone: function() {
          var clone = Base.clone.call(this);
          clone.words = this.words.slice(0);
          return clone;
        },
        random: function(nBytes) {
          var words = [];
          for (var i = 0; i < nBytes; i += 4) {
            words.push(cryptoSecureRandomInt());
          }
          return new WordArray.init(words, nBytes);
        }
      });
      var C_enc = C.enc = {};
      var Hex = C_enc.Hex = {
        stringify: function(wordArray) {
          var words = wordArray.words;
          var sigBytes = wordArray.sigBytes;
          var hexChars = [];
          for (var i = 0; i < sigBytes; i++) {
            var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
            hexChars.push((bite >>> 4).toString(16));
            hexChars.push((bite & 15).toString(16));
          }
          return hexChars.join("");
        },
        parse: function(hexStr) {
          var hexStrLength = hexStr.length;
          var words = [];
          for (var i = 0; i < hexStrLength; i += 2) {
            words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
          }
          return new WordArray.init(words, hexStrLength / 2);
        }
      };
      var Latin1 = C_enc.Latin1 = {
        stringify: function(wordArray) {
          var words = wordArray.words;
          var sigBytes = wordArray.sigBytes;
          var latin1Chars = [];
          for (var i = 0; i < sigBytes; i++) {
            var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
            latin1Chars.push(String.fromCharCode(bite));
          }
          return latin1Chars.join("");
        },
        parse: function(latin1Str) {
          var latin1StrLength = latin1Str.length;
          var words = [];
          for (var i = 0; i < latin1StrLength; i++) {
            words[i >>> 2] |= (latin1Str.charCodeAt(i) & 255) << 24 - i % 4 * 8;
          }
          return new WordArray.init(words, latin1StrLength);
        }
      };
      var Utf8 = C_enc.Utf8 = {
        stringify: function(wordArray) {
          try {
            return decodeURIComponent(escape(Latin1.stringify(wordArray)));
          } catch (e2) {
            throw new Error("Malformed UTF-8 data");
          }
        },
        parse: function(utf8Str) {
          return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
        }
      };
      var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
        reset: function() {
          this._data = new WordArray.init();
          this._nDataBytes = 0;
        },
        _append: function(data) {
          if (typeof data == "string") {
            data = Utf8.parse(data);
          }
          this._data.concat(data);
          this._nDataBytes += data.sigBytes;
        },
        _process: function(doFlush) {
          var processedWords;
          var data = this._data;
          var dataWords = data.words;
          var dataSigBytes = data.sigBytes;
          var blockSize = this.blockSize;
          var blockSizeBytes = blockSize * 4;
          var nBlocksReady = dataSigBytes / blockSizeBytes;
          if (doFlush) {
            nBlocksReady = Math2.ceil(nBlocksReady);
          } else {
            nBlocksReady = Math2.max((nBlocksReady | 0) - this._minBufferSize, 0);
          }
          var nWordsReady = nBlocksReady * blockSize;
          var nBytesReady = Math2.min(nWordsReady * 4, dataSigBytes);
          if (nWordsReady) {
            for (var offset = 0; offset < nWordsReady; offset += blockSize) {
              this._doProcessBlock(dataWords, offset);
            }
            processedWords = dataWords.splice(0, nWordsReady);
            data.sigBytes -= nBytesReady;
          }
          return new WordArray.init(processedWords, nBytesReady);
        },
        clone: function() {
          var clone = Base.clone.call(this);
          clone._data = this._data.clone();
          return clone;
        },
        _minBufferSize: 0
      });
      C_lib.Hasher = BufferedBlockAlgorithm.extend({
        cfg: Base.extend(),
        init: function(cfg) {
          this.cfg = this.cfg.extend(cfg);
          this.reset();
        },
        reset: function() {
          BufferedBlockAlgorithm.reset.call(this);
          this._doReset();
        },
        update: function(messageUpdate) {
          this._append(messageUpdate);
          this._process();
          return this;
        },
        finalize: function(messageUpdate) {
          if (messageUpdate) {
            this._append(messageUpdate);
          }
          var hash = this._doFinalize();
          return hash;
        },
        blockSize: 512 / 32,
        _createHelper: function(hasher) {
          return function(message, cfg) {
            return new hasher.init(cfg).finalize(message);
          };
        },
        _createHmacHelper: function(hasher) {
          return function(message, key) {
            return new C_algo.HMAC.init(hasher, key).finalize(message);
          };
        }
      });
      var C_algo = C.algo = {};
      return C;
    }(Math);
    return CryptoJS;
  });
})(core);
(function(module, exports) {
  (function(root, factory) {
    {
      module.exports = factory(core.exports);
    }
  })(commonjsGlobal, function(CryptoJS) {
    (function(Math2) {
      var C = CryptoJS;
      var C_lib = C.lib;
      var WordArray = C_lib.WordArray;
      var Hasher = C_lib.Hasher;
      var C_algo = C.algo;
      var H = [];
      var K = [];
      (function() {
        function isPrime(n3) {
          var sqrtN = Math2.sqrt(n3);
          for (var factor = 2; factor <= sqrtN; factor++) {
            if (!(n3 % factor)) {
              return false;
            }
          }
          return true;
        }
        function getFractionalBits(n3) {
          return (n3 - (n3 | 0)) * 4294967296 | 0;
        }
        var n2 = 2;
        var nPrime = 0;
        while (nPrime < 64) {
          if (isPrime(n2)) {
            if (nPrime < 8) {
              H[nPrime] = getFractionalBits(Math2.pow(n2, 1 / 2));
            }
            K[nPrime] = getFractionalBits(Math2.pow(n2, 1 / 3));
            nPrime++;
          }
          n2++;
        }
      })();
      var W = [];
      var SHA2562 = C_algo.SHA256 = Hasher.extend({
        _doReset: function() {
          this._hash = new WordArray.init(H.slice(0));
        },
        _doProcessBlock: function(M, offset) {
          var H2 = this._hash.words;
          var a = H2[0];
          var b = H2[1];
          var c = H2[2];
          var d = H2[3];
          var e2 = H2[4];
          var f = H2[5];
          var g = H2[6];
          var h = H2[7];
          for (var i = 0; i < 64; i++) {
            if (i < 16) {
              W[i] = M[offset + i] | 0;
            } else {
              var gamma0x = W[i - 15];
              var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
              var gamma1x = W[i - 2];
              var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
              W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
            }
            var ch = e2 & f ^ ~e2 & g;
            var maj = a & b ^ a & c ^ b & c;
            var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
            var sigma1 = (e2 << 26 | e2 >>> 6) ^ (e2 << 21 | e2 >>> 11) ^ (e2 << 7 | e2 >>> 25);
            var t1 = h + sigma1 + ch + K[i] + W[i];
            var t2 = sigma0 + maj;
            h = g;
            g = f;
            f = e2;
            e2 = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
          }
          H2[0] = H2[0] + a | 0;
          H2[1] = H2[1] + b | 0;
          H2[2] = H2[2] + c | 0;
          H2[3] = H2[3] + d | 0;
          H2[4] = H2[4] + e2 | 0;
          H2[5] = H2[5] + f | 0;
          H2[6] = H2[6] + g | 0;
          H2[7] = H2[7] + h | 0;
        },
        _doFinalize: function() {
          var data = this._data;
          var dataWords = data.words;
          var nBitsTotal = this._nDataBytes * 8;
          var nBitsLeft = data.sigBytes * 8;
          dataWords[nBitsLeft >>> 5] |= 128 << 24 - nBitsLeft % 32;
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math2.floor(nBitsTotal / 4294967296);
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
          data.sigBytes = dataWords.length * 4;
          this._process();
          return this._hash;
        },
        clone: function() {
          var clone = Hasher.clone.call(this);
          clone._hash = this._hash.clone();
          return clone;
        }
      });
      C.SHA256 = Hasher._createHelper(SHA2562);
      C.HmacSHA256 = Hasher._createHmacHelper(SHA2562);
    })(Math);
    return CryptoJS.SHA256;
  });
})(sha256);
var SHA256 = sha256.exports;
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var parse_1 = parse;
var serialize_1 = serialize;
var decode = decodeURIComponent;
var encode = encodeURIComponent;
var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
function parse(str, options) {
  if (typeof str !== "string") {
    throw new TypeError("argument str must be a string");
  }
  var obj = {};
  var opt = options || {};
  var pairs = str.split(";");
  var dec = opt.decode || decode;
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf("=");
    if (index < 0) {
      continue;
    }
    var key = pair.substring(0, index).trim();
    if (void 0 == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim();
      if (val[0] === '"') {
        val = val.slice(1, -1);
      }
      obj[key] = tryDecode(val, dec);
    }
  }
  return obj;
}
function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;
  if (typeof enc !== "function") {
    throw new TypeError("option encode is invalid");
  }
  if (!fieldContentRegExp.test(name)) {
    throw new TypeError("argument name is invalid");
  }
  var value = enc(val);
  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError("argument val is invalid");
  }
  var str = name + "=" + value;
  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError("option maxAge is invalid");
    }
    str += "; Max-Age=" + Math.floor(maxAge);
  }
  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError("option domain is invalid");
    }
    str += "; Domain=" + opt.domain;
  }
  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError("option path is invalid");
    }
    str += "; Path=" + opt.path;
  }
  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== "function") {
      throw new TypeError("option expires is invalid");
    }
    str += "; Expires=" + opt.expires.toUTCString();
  }
  if (opt.httpOnly) {
    str += "; HttpOnly";
  }
  if (opt.secure) {
    str += "; Secure";
  }
  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
    switch (sameSite) {
      case true:
        str += "; SameSite=Strict";
        break;
      case "lax":
        str += "; SameSite=Lax";
        break;
      case "strict":
        str += "; SameSite=Strict";
        break;
      case "none":
        str += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return str;
}
function tryDecode(str, decode2) {
  try {
    return decode2(str);
  } catch (e2) {
    return str;
  }
}
function hasDocumentCookie() {
  return typeof document === "object" && typeof document.cookie === "string";
}
function parseCookies(cookies, options) {
  if (typeof cookies === "string") {
    return parse_1(cookies, options);
  } else if (typeof cookies === "object" && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}
function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === "undefined") {
    doNotParse = !value || value[0] !== "{" && value[0] !== "[" && value[0] !== '"';
  }
  return !doNotParse;
}
function readCookie(value, options) {
  if (options === void 0) {
    options = {};
  }
  var cleanValue = cleanupCookieValue(value);
  if (isParsingCookie(cleanValue, options.doNotParse)) {
    try {
      return JSON.parse(cleanValue);
    } catch (e2) {
    }
  }
  return value;
}
function cleanupCookieValue(value) {
  if (value && value[0] === "j" && value[1] === ":") {
    return value.substr(2);
  }
  return value;
}
var __assign = globalThis && globalThis.__assign || function() {
  __assign = Object.assign || function(t2) {
    for (var s, i = 1, n2 = arguments.length; i < n2; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t2[p] = s[p];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
var Cookies = function() {
  function Cookies2(cookies, options) {
    var _this = this;
    this.changeListeners = [];
    this.HAS_DOCUMENT_COOKIE = false;
    this.cookies = parseCookies(cookies, options);
    new Promise(function() {
      _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
    }).catch(function() {
    });
  }
  Cookies2.prototype._updateBrowserValues = function(parseOptions) {
    if (!this.HAS_DOCUMENT_COOKIE) {
      return;
    }
    this.cookies = parse_1(document.cookie, parseOptions);
  };
  Cookies2.prototype._emitChange = function(params) {
    for (var i = 0; i < this.changeListeners.length; ++i) {
      this.changeListeners[i](params);
    }
  };
  Cookies2.prototype.get = function(name, options, parseOptions) {
    if (options === void 0) {
      options = {};
    }
    this._updateBrowserValues(parseOptions);
    return readCookie(this.cookies[name], options);
  };
  Cookies2.prototype.getAll = function(options, parseOptions) {
    if (options === void 0) {
      options = {};
    }
    this._updateBrowserValues(parseOptions);
    var result = {};
    for (var name_1 in this.cookies) {
      result[name_1] = readCookie(this.cookies[name_1], options);
    }
    return result;
  };
  Cookies2.prototype.set = function(name, value, options) {
    var _a;
    if (typeof value === "object") {
      value = JSON.stringify(value);
    }
    this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = serialize_1(name, value, options);
    }
    this._emitChange({ name, value, options });
  };
  Cookies2.prototype.remove = function(name, options) {
    var finalOptions = options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 });
    this.cookies = __assign({}, this.cookies);
    delete this.cookies[name];
    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = serialize_1(name, "", finalOptions);
    }
    this._emitChange({ name, value: void 0, options });
  };
  Cookies2.prototype.addChangeListener = function(callback) {
    this.changeListeners.push(callback);
  };
  Cookies2.prototype.removeChangeListener = function(callback) {
    var idx = this.changeListeners.indexOf(callback);
    if (idx >= 0) {
      this.changeListeners.splice(idx, 1);
    }
  };
  return Cookies2;
}();
var Cookies$1 = Cookies;
const COUNTRY_INFO = {
  "en-GB": {
    language: "en",
    country: "uk",
    currency: "gbp"
  },
  "en-IE": {
    language: "en",
    country: "ie",
    currency: "eur"
  },
  "it-IT": {
    language: "it",
    country: "it",
    currency: "eur"
  },
  "es-ES": {
    language: "es",
    country: "es",
    currency: "eur"
  },
  "en-AU": {
    language: "en",
    country: "au",
    currency: "aud"
  },
  "en-NZ": {
    language: "en",
    country: "nz",
    currency: "nzd"
  }
};
const DEFAULT_APP_ID = 7;
const DEFAULT_APP_TYPE = "web";
const IDENTITY_PROVIDERS = {
  facebook: "Facebook",
  google: "Google",
  idsrv: "Email",
  otac: "Guest",
  default: "Email"
};
const GRANT_TYPES = {
  "refresh_token": "Resume",
  registration: "Sign up",
  default: "Login"
};
const getOrientation = () => {
  if (typeof window !== "undefined") {
    const height = window.innerHeight;
    const width = window.innerWidth;
    return height > width ? "Portrait" : "Landscape";
  }
  return void 0;
};
const getCookie = (cookieName, req) => {
  const cookies = req && req.headers && req.headers.cookie ? new Cookies$1(req.headers.cookie) : new Cookies$1();
  const value = cookies.get(cookieName);
  return value;
};
const mapAnonymousUserId = (req) => {
  const value = getCookie("je-auser", req);
  return value;
};
const mapServerSidePlatformData = ({ platformData, req } = {}) => {
  const userPercent = getCookie("je-user_percentage", req);
  const mappedData = __spreadProps(__spreadValues({}, platformData), {
    jeUserPercentage: userPercent || platformData.jeUserPercentage,
    environment: process.env["justEatEnvironment"] || platformData.environment,
    version: process.env["FEATURE_VERSION"] || platformData.version,
    instancePosition: process.env["INSTANCE_POSITION"] || platformData.instancePosition,
    isPilot: process.env["IS_PILOT"] || platformData.isPilot
  });
  return mappedData;
};
const mapPlatformData = ({
  platformData,
  featureName,
  locale
} = {}) => {
  const mappedPlatformData = __spreadProps(__spreadValues({}, platformData), {
    name: featureName
  });
  mappedPlatformData.appType = DEFAULT_APP_TYPE;
  mappedPlatformData.applicationId = DEFAULT_APP_ID;
  mappedPlatformData.country = COUNTRY_INFO[locale].country;
  mappedPlatformData.language = COUNTRY_INFO[locale].language;
  mappedPlatformData.currency = COUNTRY_INFO[locale].currency;
  return mappedPlatformData;
};
const mapUserData = ({ userData, authToken, req } = {}) => {
  const userId = mapAnonymousUserId(req);
  let mappedUserData = __spreadProps(__spreadValues({}, userData), {
    "a-UserId": userId || userData["a-UserId"]
  });
  if (authToken) {
    const tokenData = o(authToken);
    const authType = (tokenData == null ? void 0 : tokenData.is_new_registration) ? GRANT_TYPES.registration : GRANT_TYPES[tokenData == null ? void 0 : tokenData.grant_type] || GRANT_TYPES.default;
    const email = (tokenData == null ? void 0 : tokenData.email) ? SHA256(tokenData == null ? void 0 : tokenData.email).toString() : userData.email;
    const globalUserId = (tokenData == null ? void 0 : tokenData.global_user_id) ? tokenData == null ? void 0 : tokenData.global_user_id : userData.globalUserId;
    const signinType = (tokenData == null ? void 0 : tokenData.role) === IDENTITY_PROVIDERS.otac ? IDENTITY_PROVIDERS.otac : IDENTITY_PROVIDERS.default;
    const signupDate = (tokenData == null ? void 0 : tokenData.created_date) ? tokenData == null ? void 0 : tokenData.created_date : userData.signupDate;
    mappedUserData = __spreadProps(__spreadValues({}, mappedUserData), {
      authType,
      email,
      globalUserId,
      signinType,
      signupDate
    });
  }
  return mappedUserData;
};
const mapPageData = ({
  pageData,
  pageName,
  httpStatusCode,
  req
} = {}) => {
  const conversationId = getCookie("x-je-conversation", req);
  const orientation = getOrientation();
  const mappedPageData = __spreadProps(__spreadValues({}, pageData), {
    name: pageName || pageData.pageName,
    conversationId: conversationId || pageData.conversationId,
    httpStatusCode: httpStatusCode || pageData.httpStatusCode,
    orientation: orientation || pageData.orientation
  });
  return mappedPageData;
};
const isDataLayerPresent = () => typeof window !== "undefined" && window.dataLayer;
const prepareServerSideValues = (store, req, options) => {
  if (typeof window === "undefined") {
    let platformData = __spreadValues({}, store.state[`${options.namespace}`].platformData);
    platformData = mapServerSidePlatformData({ platformData, req });
    store.dispatch(`${options.namespace}/updatePlatformData`, platformData);
  }
};
const preparePageTags = (options) => {
  if (typeof window !== "undefined" && !window.dataLayer) {
    const queryString = options.auth ? `&gtm_auth=${options.auth}&gtm_preview=${options.preview}&gtm_cookies_win=${options.cookiesWin}` : "";
    const headJsGtmTag = `(function (w, d, s, l, i) {
                                    w[l] = w[l] || [];
                                    w[l].push({
                                        'gtm.start': new Date().getTime(),
                                        event: 'gtm.js'
                                    });
                                    var f = d.getElementsByTagName(s)[0],
                                        j = d.createElement(s),
                                        dl = l != 'dataLayer' ? '&l=' + l : '',
                                        qs = '${queryString}';
                                    j.async = true;
                                    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl + qs;
                                    f.parentNode.insertBefore(j, f);
                                })(window, document, 'script', 'dataLayer', '${options.id}');`;
    const script = document.createElement("script");
    script.text = headJsGtmTag;
    document.head.prepend(script);
    const iframeTag = document.createElement("iframe");
    iframeTag.src = `https://www.googletagmanager.com/ns.html?id=${options.id}`;
    iframeTag.setAttribute("height", 0);
    iframeTag.setAttribute("width", 0);
    iframeTag.style.display = "none";
    iframeTag.style.visibility = "hidden";
    const noScript = document.createElement("noscript");
    noScript.appendChild(iframeTag);
    document.body.prepend(noScript);
  }
};
class AnalyticService {
  constructor(store, req, options) {
    this.store = store;
    this.req = req;
    this.options = __spreadValues(__spreadValues({}, defaultOptions), options);
    preparePageTags(this.options);
    store.registerModule(this.options.namespace, analyticsModule, { preserveState: !!store.state[`${this.options.namespace}`] });
    prepareServerSideValues(this.store, this.req, this.options);
    this.pushEvent();
  }
  getOptions() {
    return this.options;
  }
  setOptions({ featureName = this.options.featureName, locale = this.options.locale } = {}) {
    this.options = __spreadProps(__spreadValues({}, this.options), { featureName, locale });
    return this.options;
  }
  pushPlatformData({ featureName, locale, customFields } = {}) {
    let platformData = __spreadValues({}, this.store.state[`${this.options.namespace}`].platformData);
    platformData = mapPlatformData({
      platformData,
      featureName: featureName || this.options.featureName,
      locale: locale || this.options.locale
    });
    this.store.dispatch(`${this.options.namespace}/updatePlatformData`, platformData);
    if (customFields) {
      platformData = __spreadValues(__spreadValues({}, this.store.state[`${this.options.namespace}`].platformData), customFields);
    }
    if (isDataLayerPresent()) {
      window.dataLayer.push({ platformData: __spreadValues({}, platformData) });
    }
    return platformData;
  }
  pushUserData({ authToken, customFields } = {}) {
    let userData = __spreadValues({}, this.store.state[`${this.options.namespace}`].userData);
    userData = mapUserData({ userData, authToken, req: this.req });
    if (customFields) {
      userData = __spreadValues(__spreadValues({}, userData), customFields);
    }
    if (isDataLayerPresent()) {
      window.dataLayer.push({ userData: __spreadValues({}, userData) });
    }
    return userData;
  }
  pushPageData({
    pageName,
    conversationId,
    httpStatusCode,
    customFields
  } = {}) {
    let pageData = __spreadValues({}, this.store.state[`${this.options.namespace}`].pageData);
    pageData = mapPageData({
      pageData,
      pageName,
      conversationId,
      httpStatusCode,
      req: this.req
    });
    if (customFields) {
      pageData = __spreadValues(__spreadValues({}, pageData), customFields);
    }
    if (isDataLayerPresent()) {
      window.dataLayer.push({ pageData: __spreadValues({}, pageData) });
    }
    return pageData;
  }
  pushEvent(event) {
    if (event) {
      this.store.dispatch(`${this.options.namespace}/updateEvents`, event);
    }
    if (isDataLayerPresent()) {
      const events = [...this.store.state[`${this.options.namespace}`].events];
      events.forEach((e2) => window.dataLayer.push(JSON.parse(JSON.stringify(e2))));
      this.store.dispatch(`${this.options.namespace}/clearEvents`);
    }
    return event;
  }
}
export { AnalyticService as default };
//# sourceMappingURL=f-analytics.es.js.map
